import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { ManagementSupportCommentModel } from '@data-layer/models/management';

export type SupportCommentsEntityType = 'entry-summary' | 'isf';

@Injectable({
  providedIn: 'root',
})
export class SupportCommentsRepository {
  constructor(private apiService: ApiService) {}

  public getComments(entityType: SupportCommentsEntityType, entityId: number): Observable<ManagementSupportCommentModel[]> {
    return this.apiService.get<ManagementSupportCommentModel[]>(this.baseUrl(entityType, entityId));
  }

  public addComment(entityType: SupportCommentsEntityType, entityId: number, text: string): Observable<void> {
    return this.apiService.post<void>(this.baseUrl(entityType, entityId), { text });
  }

  public editComment(entityType: SupportCommentsEntityType, entityId: number, commentId: number, text: string): Observable<void> {
    return this.apiService.put<void>(`${this.baseUrl(entityType, entityId)}/${commentId}`, { text });
  }

  public deleteComment(entityType: SupportCommentsEntityType, entityId: number, commentId: number): Observable<void> {
    return this.apiService.delete<void>(`${this.baseUrl(entityType, entityId)}/${commentId}`);
  }

  private baseUrl(entityType: SupportCommentsEntityType, entityId: number): string {
    return entityType === 'entry-summary'
      ? `${environment.url.esManagement}${entityId}/support-comments`
      : `${environment.url.prefixCustoms}v2/management/isfs/${entityId}/support-comments`;
  }
}
